import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VProgressLinear,{staticClass:"my-2",attrs:{"indeterminate":"","color":"rgba(0, 0, 0, 0.12)","height":"12"}}),_c(VProgressLinear,{staticClass:"my-2",attrs:{"indeterminate":"","color":"rgba(0, 0, 0, 0.12)","height":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }